import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats, features, reputations, faqs } from '@/mocks/data';

function Breadcrumb() {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-foreground-500">
      <a href="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</a>
      <div className="w-3 h-3 flex items-center justify-center">
        <i className="ri-arrow-right-s-line text-xs"></i>
      </div>
      <span className="text-foreground-900 font-medium">关于我们</span>
    </nav>
  );
}

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16">
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 mb-8">
          <Breadcrumb />
        </div>

        {/* Hero Banner */}
        <section className="relative w-full py-16 md:py-20 overflow-hidden mb-0">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20interior%20space%20with%20soft%20golden%20lighting%2C%20modern%20office%20lounge%20with%20comfortable%20seating%2C%20subtle%20branding%20elements%2C%20professional%20yet%20inviting%20atmosphere%2C%20dark%20wood%20accents%20and%20warm%20ambient%20glow&width=1920&height=500&seq=about-hero&orientation=landscape"
              alt="撸撸社官网 - 关于我们"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
              关于撸撸社官网
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
              撸撸社官网作为用户信赖的官方平台，致力于为每一位用户提供最优质的娱乐内容体验
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    撸撸社官网成立于2020年，是业内领先的综合娱乐内容平台。我们始终坚持<strong>"用户至上、内容为王"</strong>的核心理念，致力于为用户提供最优质的观影体验。
                  </p>
                  <p>
                    作为<strong>撸撸社官方网站</strong>，我们拥有超过10万部正版授权内容，涵盖热门电影、经典回顾、动漫精选、综艺娱乐等多个分类，满足不同用户的多样化观影需求。
                  </p>
                  <p>
                    撸撸社官网采用全球CDN加速技术，确保每一位用户都能享受<strong>极速播放</strong>的流畅体验。同时，我们提供7×24小时全天候客服支持，随时解决用户在使用过程中遇到的任何问题。
                  </p>
                  <p>
                    截至目前，撸撸社官网已累计服务超过<strong>500万注册用户</strong>，日均播放量突破300万次，用户好评率高达99.2%。这些数字的背后，是撸撸社团队对品质的不懈追求。
                  </p>
                </div>
              </div>
              <div className="relative w-full h-[350px] md:h-[400px] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20tech%20company%20workspace%20with%20warm%20lighting%2C%20creative%20team%20collaboration%20scene%2C%20large%20screens%20displaying%20content%2C%20professional%20yet%20relaxed%20atmosphere%2C%20dark%20wood%20and%20warm%20amber%20accents%2C%20editorial%20photography%20style&width=800&height=600&seq=about-brand&orientation=portrait"
                  alt="撸撸社品牌文化"
                  title="撸撸社官网 - 品牌文化"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats Counter */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, idx) => (
                <div key={idx} className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">{stat.value}</div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Features */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                平台优势
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                选择撸撸社官网的六大理由
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-6 cursor-default"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-4">
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation Testimonials */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                用户口碑
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                听听撸撸社的真实用户怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {reputations.map((rep, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-6"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                      <img src={rep.avatar} alt={rep.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900">{rep.name}</h4>
                      <p className="text-xs text-foreground-500">{rep.role}</p>
                    </div>
                    <div className="ml-auto flex items-center gap-0.5">
                      {Array.from({ length: rep.rating }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-amber-400 text-sm"></i>
                        </div>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{rep.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Contact Form */}
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 mb-8">
                  如有任何问题或建议，欢迎通过以下方式联系我们。撸撸社客服团队将竭诚为您服务。
                </p>
                <form
                  data-readdy-form
                  id="contact-form"
                  action="https://readdy.ai/api/form/d9rhnq4nlsngrm4lmc90"
                  method="POST"
                  className="space-y-5"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);

                    const hpField = formData.get('phone_alt');
                    if (hpField && (hpField as string).trim() !== '') {
                      const successMsg = document.getElementById('contact-success');
                      if (successMsg) successMsg.style.display = 'block';
                      form.reset();
                      return;
                    }

                    try {
                      const res = await fetch(form.action, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await res.text();
                      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
                      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

                      if (res.ok && parsed.code === 'OK') {
                        const successMsg = document.getElementById('contact-success');
                        if (successMsg) successMsg.style.display = 'block';
                        const errorMsg = document.getElementById('contact-error');
                        if (errorMsg) errorMsg.style.display = 'none';
                        form.reset();
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
                        const errorEl = document.getElementById('contact-error-text');
                        if (errorEl) errorEl.textContent = serverMsg || '提交失败，请稍后再试';
                        const errorBox = document.getElementById('contact-error');
                        if (errorBox) errorBox.style.display = 'block';
                      }
                    } catch {
                      const errorEl = document.getElementById('contact-error-text');
                      if (errorEl) errorEl.textContent = '网络异常，请稍后再试';
                      const errorBox = document.getElementById('contact-error');
                      if (errorBox) errorBox.style.display = 'block';
                    }
                  }}
                >
                  <input
                    type="text"
                    name="phone_alt"
                    className="form-hp-field"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱地址"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                    <input
                      type="text"
                      id="contact-subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入咨询主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                    <p className="text-xs text-foreground-500 mt-1">最多500字</p>
                  </div>
                  <div id="contact-success" style={{ display: 'none' }} className="p-4 bg-accent-100/50 border border-accent-300 rounded-md">
                    <p className="text-sm text-accent-800 font-medium">提交成功！感谢您的留言，我们将尽快与您联系。</p>
                  </div>
                  <div id="contact-error" style={{ display: 'none' }} className="p-4 bg-red-50 border border-red-300 rounded-md">
                    <p id="contact-error-text" className="text-sm text-red-700 font-medium"></p>
                  </div>
                  <button
                    type="submit"
                    className="w-full px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                </form>
              </div>

              {/* Contact Info */}
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  联系方式
                </h2>
                <p className="text-sm text-foreground-600 mb-8">
                  您也可以通过以下方式直接联系我们
                </p>
                <div className="space-y-6">
                  <div className="flex items-start gap-4 p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">service@lulushe.com</p>
                      <p className="text-xs text-foreground-500 mt-1">工作日24小时内回复</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h3>
                      <p className="text-sm text-foreground-600">400-XXX-XXXX</p>
                      <p className="text-xs text-foreground-500 mt-1">7×24小时全天候服务</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">服务时间</h3>
                      <p className="text-sm text-foreground-600">周一至周日 全天24小时</p>
                      <p className="text-xs text-foreground-500 mt-1">节假日正常服务</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                      <p className="text-sm text-foreground-600">中国上海市浦东新区张江高科技园区</p>
                      <p className="text-xs text-foreground-500 mt-1">欢迎预约来访</p>
                    </div>
                  </div>
                </div>

                {/* FAQ */}
                <div className="mt-12">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">常见问题</h3>
                  <div className="space-y-2">
                    {faqs.slice(0, 4).map((faq, idx) => (
                      <details key={idx} className="group border border-background-200/70 rounded-lg overflow-hidden">
                        <summary className="flex items-center justify-between p-4 cursor-pointer bg-background-50 hover:bg-background-100 transition-colors list-none">
                          <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                          <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-300">
                            <i className="ri-add-line text-foreground-500"></i>
                          </div>
                        </summary>
                        <div className="px-4 pb-4">
                          <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                        </div>
                      </details>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}